import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'

const CompanyMoto = ({ title, subtitle, images }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.descriptionBox}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.subtitle}>
            {subtitle.subtitle.split('\n')[0]}
          </div>
          <div className={styles.motto}>{subtitle.subtitle.split('\n')[1]}</div>
        </div>
        <div className={styles.imageWrapper}>
          <div className={styles.imageBox}>
            <GatsbyImage
              image={images[0].gatsbyImageData}
              alt={images[0].description}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyMoto
